import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { css } from "@mui/material/styles";
import { NavLink } from "react-router-dom";
import { COLOR_GREY_10, COLOR_MENU, COLOR_WHITE } from "shared/theme/colors";

export const StyledDotContainer = styled(Box)`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-right: 1rem;
`;

export const StyledIconContainer = styled(Box)`
  svg > path {
    fill: ${COLOR_MENU};
  }
`;

export const StyledDot = styled(Box, {
  shouldForwardProp: (props) => props !== "active",
})<{
  active: boolean;
}>`
  width: ${({ active }) => (active ? "6px" : "4px")};
  height: ${({ active }) => (active ? "6px" : "4px")};
  background-color: ${COLOR_GREY_10};
  border-radius: 100%;

  ${(props) =>
    props.active &&
    css`
      background-color: ${COLOR_WHITE};
    `}
`;

export const StyledSubItemLink = styled(NavLink, {
  shouldForwardProp: (propName) => propName !== "active",
})<{ active: boolean }>`
  display: flex;
  align-items: center;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 0.5rem;
  text-decoration: none;
  height: 40px;
  box-sizing: border-box;

  svg > path {
    fill: ${COLOR_WHITE};
  }

  :hover {
    .MuiTypography-root {
      color: ${COLOR_WHITE};
    }
  }

  ${(props) =>
    props.active &&
    css`
      .MuiTypography-root {
        color: ${COLOR_WHITE};
      }
    `}
`;
